import _regeneratorRuntime from "@babel/runtime/regenerator";

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } it = o[Symbol.iterator](); return it.next.bind(it); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Button, Classes, Icon, Menu, Popover, Position, Tooltip } from "@blueprintjs/core";
import Dropzone from "react-dropzone"; // import { first } from "lodash";

import classnames from "classnames";
import { nanoid } from "nanoid";
import papaparse from "papaparse";
import downloadjs from "downloadjs";
import UploadCsvWizardDialog, { SimpleInsertDataDialog } from "../UploadCsvWizard";
import { useDialog } from "../useDialog";
import { isCsvOrExcelFile, parseCsvOrExcelFile, removeExt } from "../utils/parserUtils";
import tryToMatchSchemas from "./tryToMatchSchemas";
import { isArray, isFunction, isPlainObject } from "lodash";
import { flatMap } from "lodash";
import urljoin from "url-join";

function noop() {} // wink wink


var emptyPromise = Promise.resolve.bind(Promise);

function Uploader(_ref) {
  var _window, _window$frontEndConfi;

  var _accept = _ref.accept,
      maybeContentOverride = _ref.contentOverride,
      innerIcon = _ref.innerIcon,
      innerText = _ref.innerText,
      action = _ref.action,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      minimal = _ref.minimal,
      validateAgainstSchema = _ref.validateAgainstSchema,
      fileLimit = _ref.fileLimit,
      readBeforeUpload = _ref.readBeforeUpload,
      uploadInBulk = _ref.uploadInBulk,
      _ref$showUploadList = _ref.showUploadList,
      showUploadList = _ref$showUploadList === void 0 ? true : _ref$showUploadList,
      beforeUpload = _ref.beforeUpload,
      fileList = _ref.fileList,
      _ref$onFileSuccess = _ref.onFileSuccess,
      onFileSuccess = _ref$onFileSuccess === void 0 ? emptyPromise : _ref$onFileSuccess,
      _ref$onFieldSubmit = _ref.onFieldSubmit,
      onFieldSubmit = _ref$onFieldSubmit === void 0 ? noop : _ref$onFieldSubmit,
      _ref$onRemove = _ref.onRemove,
      onRemove = _ref$onRemove === void 0 ? noop : _ref$onRemove,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      onFileClick = _ref.onFileClick,
      _ref$dropzoneProps = _ref.dropzoneProps,
      dropzoneProps = _ref$dropzoneProps === void 0 ? {} : _ref$dropzoneProps,
      overflowList = _ref.overflowList,
      disabled = _ref.disabled,
      showFilesCount = _ref.showFilesCount,
      threeDotMenuItems = _ref.threeDotMenuItems,
      onPreviewClick = _ref.onPreviewClick,
      _ref$axiosInstance = _ref.axiosInstance,
      axiosInstance = _ref$axiosInstance === void 0 ? window.api || axios : _ref$axiosInstance;
  var accept = isPlainObject(_accept) ? [_accept] : _accept;

  var _useState = useState(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var filesToClean = useRef([]);

  var _useDialog = useDialog({
    ModalComponent: UploadCsvWizardDialog
  }),
      showUploadCsvWizardDialog = _useDialog.showDialogPromise,
      comp = _useDialog.comp;

  var _useDialog2 = useDialog({
    ModalComponent: SimpleInsertDataDialog
  }),
      showSimpleInsertDataDialog = _useDialog2.showDialogPromise,
      comp2 = _useDialog2.comp;

  function cleanupFiles() {
    filesToClean.current.forEach(function (file) {
      return URL.revokeObjectURL(file.preview);
    });
  }

  useEffect(function () {
    return function () {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      cleanupFiles();
    };
  });
  var contentOverride = maybeContentOverride;

  if (contentOverride && typeof contentOverride === "function") {
    contentOverride = contentOverride({
      loading: loading
    });
  }

  var simpleAccept;
  var advancedAccept;

  if (Array.isArray(accept)) {
    if (accept.some(function (a) {
      return isPlainObject(a);
    })) {
      //advanced accept
      advancedAccept = accept;
      simpleAccept = flatMap(accept, function (a) {
        if (a.type) return a.type;
        return a;
      });
      simpleAccept = simpleAccept.join(", ");
    } else {
      simpleAccept = accept.join(", ");
    }
  } else {
    simpleAccept = accept;
  }

  var fileListToUse = fileList ? fileList : [];

  function handleSecondHalfOfUpload(_x) {
    return _handleSecondHalfOfUpload.apply(this, arguments);
  }

  function _handleSecondHalfOfUpload() {
    _handleSecondHalfOfUpload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2) {
      var acceptedFiles, cleanedFileList, keepGoing, responses;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              acceptedFiles = _ref2.acceptedFiles, cleanedFileList = _ref2.cleanedFileList;
              onChange(cleanedFileList); //tnw: this line is necessary, if you want to clear the file list in the beforeUpload, call onChange([])
              // beforeUpload is called, otherwise beforeUpload will not be able to truly cancel the upload

              if (!beforeUpload) {
                _context3.next = 8;
                break;
              }

              _context3.next = 5;
              return beforeUpload(cleanedFileList, onChange);

            case 5:
              _context3.t0 = _context3.sent;
              _context3.next = 9;
              break;

            case 8:
              _context3.t0 = true;

            case 9:
              keepGoing = _context3.t0;

              if (keepGoing) {
                _context3.next = 12;
                break;
              }

              return _context3.abrupt("return");

            case 12:
              if (!action) {
                _context3.next = 22;
                break;
              }

              if (!uploadInBulk) {
                _context3.next = 16;
                break;
              }

              _context3.next = 20;
              break;

            case 16:
              responses = [];
              _context3.next = 19;
              return Promise.all(acceptedFiles.map(function (fileToUpload) {
                var data = new FormData();
                data.append("file", fileToUpload);
                return axiosInstance.post(action, data).then(function (res) {
                  responses.push(res.data && res.data[0]);
                  onFileSuccess(res.data[0]).then(function () {
                    cleanedFileList = cleanedFileList.map(function (file) {
                      var fileToReturn = _extends({}, file, res.data[0]);

                      if (fileToReturn.id === fileToUpload.id) {
                        fileToReturn.loading = false;
                      }

                      return fileToReturn;
                    });
                    onChange(cleanedFileList);
                  });
                })["catch"](function (err) {
                  console.error("Error uploading file:", err);
                  responses.push(_extends({}, fileToUpload, {
                    error: err && err.msg ? err.msg : err
                  }));
                  cleanedFileList = cleanedFileList.map(function (file) {
                    var fileToReturn = _extends({}, file);

                    if (fileToReturn.id === fileToUpload.id) {
                      fileToReturn.loading = false;
                      fileToReturn.error = true;
                    }

                    return fileToReturn;
                  });
                  onChange(cleanedFileList);
                });
              }));

            case 19:
              onFieldSubmit(responses);

            case 20:
              _context3.next = 23;
              break;

            case 22:
              onChange(cleanedFileList.map(function (file) {
                return _extends({}, file, {
                  loading: false
                });
              }));

            case 23:
              setLoading(false);

            case 24:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _handleSecondHalfOfUpload.apply(this, arguments);
  }

  var baseUrl = ((_window = window) == null ? void 0 : (_window$frontEndConfi = _window.frontEndConfig) == null ? void 0 : _window$frontEndConfi.serverBasePath) || "";
  return /*#__PURE__*/React.createElement("div", {
    className: "tg-uploader-outer",
    style: {
      width: minimal ? undefined : "100%",
      display: "flex",
      height: "fit-content"
    }
  }, comp, comp2, /*#__PURE__*/React.createElement("div", {
    className: "tg-uploader-inner",
    style: {
      width: "100%",
      height: "fit-content",
      minWidth: 0
    }
  }, simpleAccept && /*#__PURE__*/React.createElement("div", {
    className: Classes.TEXT_MUTED,
    style: {
      fontSize: 11,
      marginBottom: 5
    }
  }, advancedAccept ? /*#__PURE__*/React.createElement("div", {
    style: {}
  }, "Accepts \xA0", /*#__PURE__*/React.createElement("span", {
    style: {}
  }, advancedAccept.map(function (a, i) {
    var disabled = !(a.description || a.exampleFile);
    var CustomTag = !a.exampleFile ? "span" : "a";
    return /*#__PURE__*/React.createElement(Tooltip, {
      key: i,
      disabled: disabled,
      content: /*#__PURE__*/React.createElement("div", null, a.description ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 4,
          fontStyle: "italic"
        }
      }, a.description) : "", a.exampleFile && "Download Example File")
    }, /*#__PURE__*/React.createElement(CustomTag, _extends({
      className: "tgFileTypeDescriptor",
      style: {
        marginRight: 10,
        cursor: "pointer"
      }
    }, isFunction(a.exampleFile) ? {
      onClick: a.exampleFile
    } : a.exampleFile && {
      href: urljoin(baseUrl, "exampleFiles", a.exampleFile)
    }), (a.type ? isArray(a.type) ? a.type : [a.type] : [a]).map(function (t) {
      return t.startsWith(".") ? t : "." + t;
    }).join(", "), a.exampleFile && /*#__PURE__*/React.createElement(Icon, {
      style: {
        marginTop: 3,
        marginLeft: 3
      },
      size: 10,
      icon: "download"
    })));
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, "Accepts ", simpleAccept)), /*#__PURE__*/React.createElement(Dropzone, _extends({
    disabled: disabled,
    onClick: function onClick(evt) {
      return evt.preventDefault();
    },
    multiple: fileLimit !== 1,
    accept: simpleAccept ? simpleAccept.split(", ").map(function (a) {
      return a.startsWith(".") ? a : "." + a;
    }).join(", ") : undefined,
    onDrop: function () {
      var _onDrop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(acceptedFiles, rejectedFiles) {
        var msg, cleanedFileList, filesWIssues, _iterator, _step, _file, parsedF, _tryToMatchSchemas, _csvValidationIssue, initialMatchedHeaders, userSchema, searchResults, _newFile, _newFileName, _filesWIssues$, file, name, csvValidationIssue, rest, _yield$showUploadCsvW, newEntities, newFileName, newFile;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cleanupFiles();

                if (rejectedFiles.length) {
                  msg = "";
                  rejectedFiles.forEach(function (file) {
                    if (msg) msg += "\n";
                    msg += file.file.name + ": " + file.errors.map(function (err) {
                      return err.message;
                    }).join(", ");
                  });
                  window.toastr && window.toastr.warning( /*#__PURE__*/React.createElement("div", {
                    className: "preserve-newline"
                  }, msg));
                }

                if (acceptedFiles.length) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                setLoading(true);

                if (fileLimit) {
                  acceptedFiles = acceptedFiles.slice(0, fileLimit);
                }

                acceptedFiles.forEach(function (file) {
                  file.preview = URL.createObjectURL(file);
                  file.loading = true;

                  if (!file.id) {
                    file.id = nanoid();
                  }

                  filesToClean.current.push(file);
                });

                if (!readBeforeUpload) {
                  _context.next = 11;
                  break;
                }

                _context.next = 10;
                return Promise.all(acceptedFiles.map(function (file) {
                  return new Promise(function (resolve, reject) {
                    var reader = new FileReader();
                    reader.readAsText(file, "UTF-8");

                    reader.onload = function (evt) {
                      file.parsedString = evt.target.result;
                      resolve(file);
                    };

                    reader.onerror = function (err) {
                      console.error("err:", err);
                      reject(err);
                    };
                  });
                }));

              case 10:
                acceptedFiles = _context.sent;

              case 11:
                cleanedFileList = [].concat(acceptedFiles.map(function (file) {
                  return _extends({
                    originFileObj: file,
                    originalFileObj: file,
                    id: file.id,
                    lastModified: file.lastModified,
                    lastModifiedDate: file.lastModifiedDate,
                    loading: file.loading,
                    name: file.name,
                    preview: file.preview,
                    size: file.size,
                    type: file.type
                  }, file.parsedString ? {
                    parsedString: file.parsedString
                  } : {});
                }), fileListToUse).slice(0, fileLimit ? fileLimit : undefined);

                if (!validateAgainstSchema) {
                  _context.next = 42;
                  break;
                }

                filesWIssues = [];
                _iterator = _createForOfIteratorHelperLoose(cleanedFileList);

              case 15:
                if ((_step = _iterator()).done) {
                  _context.next = 25;
                  break;
                }

                _file = _step.value;

                if (!isCsvOrExcelFile(_file)) {
                  _context.next = 23;
                  break;
                }

                _context.next = 20;
                return parseCsvOrExcelFile(_file);

              case 20:
                parsedF = _context.sent;
                _tryToMatchSchemas = tryToMatchSchemas({
                  incomingData: parsedF.data,
                  validateAgainstSchema: validateAgainstSchema
                }), _csvValidationIssue = _tryToMatchSchemas.csvValidationIssue, initialMatchedHeaders = _tryToMatchSchemas.initialMatchedHeaders, userSchema = _tryToMatchSchemas.userSchema, searchResults = _tryToMatchSchemas.searchResults;

                if (_csvValidationIssue) {
                  filesWIssues.push({
                    file: _file,
                    csvValidationIssue: _csvValidationIssue,
                    initialMatchedHeaders: initialMatchedHeaders,
                    userSchema: userSchema,
                    searchResults: searchResults
                  });
                } else {
                  _newFile = new File([papaparse.unparse(userSchema.userData)], _file.name);
                  _newFileName = removeExt(_file.name) + ".csv";
                  _file.name = _newFileName;
                  _file.originFileObj = _newFile;
                  _file.originalFileObj = _newFile;
                }

              case 23:
                _context.next = 15;
                break;

              case 25:
                if (!filesWIssues.length) {
                  _context.next = 42;
                  break;
                }

                _filesWIssues$ = filesWIssues[0], file = _filesWIssues$.file, name = _filesWIssues$.name, csvValidationIssue = _filesWIssues$.csvValidationIssue, rest = _objectWithoutPropertiesLoose(_filesWIssues$, ["file", "name", "csvValidationIssue"]); //just handle the 1st file for now

                _context.next = 29;
                return showUploadCsvWizardDialog("onUploadWizardFinish", _extends({}, rest, {
                  dialogProps: {
                    title: "Fix Up File " + (file.name ? "\"" + file.name + "\"" : "")
                  },
                  csvValidationIssue: csvValidationIssue,
                  validateAgainstSchema: validateAgainstSchema
                }));

              case 29:
                _yield$showUploadCsvW = _context.sent;
                newEntities = _yield$showUploadCsvW.newEntities;

                if (newEntities) {
                  _context.next = 36;
                  break;
                }

                window.toastr.warning("File Upload Aborted");
                return _context.abrupt("return");

              case 36:
                newFileName = removeExt(file.name) + "_updated.csv"; //swap out file with a new csv file

                newFile = new File([papaparse.unparse(newEntities)], newFileName);
                file.name = newFileName;
                file.originFileObj = newFile;
                file.originalFileObj = newFile;
                window.toastr.success("Added Fixed Up File " + newFileName);

              case 42:
                handleSecondHalfOfUpload({
                  acceptedFiles: acceptedFiles,
                  cleanedFileList: cleanedFileList
                });

              case 43:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onDrop(_x2, _x3) {
        return _onDrop.apply(this, arguments);
      }

      return onDrop;
    }()
  }, dropzoneProps), function (_ref3) {
    var getRootProps = _ref3.getRootProps,
        getInputProps = _ref3.getInputProps,
        isDragAccept = _ref3.isDragAccept,
        isDragReject = _ref3.isDragReject,
        isDragActive = _ref3.isDragActive;
    return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", _extends({}, getRootProps(), {
      className: classnames("tg-dropzone", className, {
        "tg-dropzone-minimal": minimal,
        "tg-dropzone-active": isDragActive,
        "tg-dropzone-reject": isDragReject,
        // tnr: the acceptClassName/rejectClassName doesn't work with file extensions (only mimetypes are supported when dragging). Thus we'll just always turn the drop area blue when dragging and let the filtering occur on drop. See https://github.com/react-dropzone/react-dropzone/issues/888#issuecomment-773938074
        "tg-dropzone-accept": isDragAccept,
        "tg-dropzone-disabled": disabled
      })
    }), /*#__PURE__*/React.createElement("input", getInputProps()), contentOverride || /*#__PURE__*/React.createElement("div", {
      title: simpleAccept ? "Accepts only the following file types: " + simpleAccept : "Accepts any file input",
      className: "tg-upload-inner"
    }, innerIcon || /*#__PURE__*/React.createElement(Icon, {
      icon: "upload",
      iconSize: minimal ? 15 : 30
    }), innerText || (minimal ? "Upload" : "Click or drag to upload"))), validateAgainstSchema && /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: "center",
        fontSize: 18,
        marginTop: 7,
        marginBottom: 5
      },
      onClick: /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
          var _yield$showSimpleInse, newEntities, newFileName, newFile, file, cleanedFileList;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  e.stopPropagation();
                  _context2.next = 3;
                  return showSimpleInsertDataDialog("onSimpleInsertDialogFinish", {
                    validateAgainstSchema: validateAgainstSchema
                  });

                case 3:
                  _yield$showSimpleInse = _context2.sent;
                  newEntities = _yield$showSimpleInse.newEntities;

                  if (newEntities) {
                    _context2.next = 9;
                    break;
                  }

                  return _context2.abrupt("return");

                case 9:
                  newFileName = "manual_data_entry.csv";
                  newFile = new File([papaparse.unparse(newEntities)], newFileName);
                  file = _extends({}, newFile, {
                    name: newFileName,
                    originFileObj: newFile,
                    originalFileObj: newFile,
                    id: nanoid()
                  });
                  cleanedFileList = [file].concat(fileListToUse).slice(0, fileLimit ? fileLimit : undefined);
                  handleSecondHalfOfUpload({
                    acceptedFiles: cleanedFileList,
                    cleanedFileList: cleanedFileList
                  });
                  window.toastr.success("File Added");

                case 15:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x4) {
          return _ref4.apply(this, arguments);
        };
      }(),
      className: "link-button"
    }, ".. or manually enter data"), showFilesCount ? /*#__PURE__*/React.createElement("div", {
      className: "tg-upload-file-list-counter"
    }, "Files: ", fileList ? fileList.length : 0) : null);
  }), fileList && showUploadList && !minimal && !!fileList.length && /*#__PURE__*/React.createElement("div", {
    className: overflowList ? "tg-upload-file-list-item-overflow" : null
  }, fileList.map(function (file, index) {
    var loading = file.loading,
        error = file.error,
        name = file.name,
        originalName = file.originalName,
        url = file.url,
        downloadName = file.downloadName;
    var icon;
    var isPreviewable = false;

    if (loading) {
      icon = "repeat";
    } else if (error) {
      icon = "error";
    } else {
      if (onPreviewClick) {
        isPreviewable = true;
        icon = "eye-open";
      } else {
        icon = "saved";
      }
    }

    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "tg-upload-file-list-item",
      style: {
        display: "flex",
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      className: classnames({
        "tg-spin": loading,
        "tg-upload-file-list-item-preview": isPreviewable
      }),
      style: {
        marginRight: 5
      },
      icon: icon,
      onClick: function onClick() {
        if (isPreviewable) {
          onPreviewClick(file, index, fileList);
        }
      }
    }), /*#__PURE__*/React.createElement("a", _extends({
      name: name || originalName
    }, url && !onFileClick ? {
      href: url
    } : {}, {
      /* eslint-disable react/jsx-no-bind*/
      onClick: function onClick() {
        if (onFileClick) {
          onFileClick(file);
        } else {
          //handle default download
          if (file.originFileObj) {
            downloadjs(file.originFileObj, file.name);
          }
        }
      }
      /* eslint-enable react/jsx-no-bind*/

    }, downloadName ? {
      download: downloadName
    } : {}), " ", name || originalName, " "), !loading && /*#__PURE__*/React.createElement(Icon, {
      onClick: function onClick() {
        onRemove(file, index, fileList);
        onChange(fileList.filter(function (file, index2) {
          return index2 !== index;
        }));
      },
      iconSize: 16,
      icon: "cross",
      className: "tg-upload-file-list-item-close"
    })));
  }))), threeDotMenuItems && /*#__PURE__*/React.createElement("div", {
    className: "tg-dropzone-extra-options"
  }, /*#__PURE__*/React.createElement(Popover, {
    autoFocus: false,
    minimal: true,
    content: /*#__PURE__*/React.createElement(Menu, null, threeDotMenuItems),
    position: Position.BOTTOM_RIGHT
  }, /*#__PURE__*/React.createElement(Button, {
    minimal: true,
    icon: "more"
  }))));
}

export default Uploader;